import Image from 'next/image';
import Link from 'next/link';


interface CaseStudySummary {
  title: string;
  slug: string;
  featuredImage: string;
}

interface Props {
  caseStudies: CaseStudySummary[];
}

export const CaseStudyPostsSection = ({ caseStudies }: Props) => {

  return (
    <section className="w-full bg-lupine-50 overflow-hidden px-4 pt-16 pb-32">
      <div className="max-w-5xl mx-auto">
        <CaseStudyList caseStudies={caseStudies} />
      </div>
    </section>
  );
};

const CaseStudyList = ({ caseStudies }: { caseStudies: CaseStudySummary[] }) => {
  return (
    <ul className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 gap-16">
      {caseStudies.map((caseStudy, index) => (
        <li key={caseStudy.slug}>
          <Link
            href={`/case-studies/${caseStudy.slug}`}
            className="block group rounded focus-visible:outline outline-2 outline-offset-4 outline-plum-500"
          >
            <div className="flex flex-col gap-6">
              <Image
                src={caseStudy.featuredImage}
                width={500}
                height={240}
                alt=""
                priority={index < 2}
                className="w-full h-60 rounded-xl object-cover"
              />
              <h2
                className="font-sans font-medium text-2xl text-plum-950 -tracking-[0.03em] group-hover:text-plum-800 transition-colors">
                {caseStudy.title}
              </h2>
            </div>
          </Link>
        </li>
      ))}
    </ul>
  );
};
